import React, { Component } from 'react';
const { connect } = require('react-redux');

import HeaderActivateRegistration from '../components/registration/HeaderActivateRegistration';
import Footer from '../components/Footer';

import { activateRegisterUser } from 'backend-helpers/member';
import {setCurrentUser} from "../reducers/currentUser";

class ActivateRegistration extends Component {

    constructor(props) {
        super(props);

        this.state = {}

        this.onActivateSuccess = this.onActivateSuccess.bind(this);
    }

    componentDidMount() {
        const { sid } = this.props.match.params;

        const params = {
            SID: sid
        };

        activateRegisterUser(params).then(this.onActivateSuccess)
    }

    onActivateSuccess(response) {
        const {dispatch} = this.props;

        dispatch(setCurrentUser(response.data.user));
        this.setState({...response.data})
    }

    render() {
        const { 
            status,
            message 
        } = this.state;

        const { sid } = this.props.match.params;

        return (
            <div id="wrapper">
                <HeaderActivateRegistration
                    sid={sid}
                    status={status}
                    message={message}
                />
                <Footer />
            </div>
        )
    }
}

export default connect()(ActivateRegistration);



// WEBPACK FOOTER //
// ./src/containers/ActivateRegistration.js